import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tshirt-print-limitation',
  templateUrl: './tshirt-print-limitation.component.html',
  styleUrls: ['./tshirt-print-limitation.component.scss']
})
export class TshirtPrintLimitationComponent implements OnInit {

	cmsContent: any = null;
	onClose: any;

	constructor(
	) { }

	ngOnInit(): void {

	}

}
